import { BaseService } from "../../core/baseService";
import {
  GuestPortalPreviewSessionDto,
  HotelSettingsServiceInterface,
} from "../types/hotelSettings.types";
import { HotelSettingsDto, SaveHotelSettingsDto } from "../../../models";
import { ApiResult } from "../../core/types";

export class HotelSettingsService
  extends BaseService
  implements HotelSettingsServiceInterface
{
  async getSettings(): Promise<ApiResult<HotelSettingsDto>> {
    return this.handleRequest<HotelSettingsDto>(
      this.client.get("/api/admin/hotel-settings"),
    );
  }

  async updateSettings(
    settings: SaveHotelSettingsDto,
  ): Promise<ApiResult<boolean>> {
    return this.handleRequest<boolean>(
      this.client.put("/api/admin/hotel-settings", settings),
    );
  }

  async uploadLogo(file: File): Promise<ApiResult<{ url: string }>> {
    const formData = new FormData();
    formData.append("file", file);

    return this.handleRequest<{ url: string }>(
      this.client.post("/api/admin/hotel-settings/logo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    );
  }

  async uploadGuestAsset(file: File): Promise<ApiResult<{ url: string }>> {
    const formData = new FormData();
    formData.append("file", file);

    return this.handleRequest<{ url: string }>(
      this.client.post("/api/admin/hotel-settings/guest-asset", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    );
  }

  async createPreviewSession(
    sourceTokenKey?: string | null,
  ): Promise<ApiResult<GuestPortalPreviewSessionDto>> {
    const payload =
      sourceTokenKey && sourceTokenKey.trim().length > 0
        ? { sourceTokenKey: sourceTokenKey.trim() }
        : {};

    return this.handleRequest<GuestPortalPreviewSessionDto>(
      this.client.post("/api/admin/hotel-settings/preview/session", payload),
    );
  }
}
